import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from '../../shared/shared.module';
import { PoliciesModule } from '../../shared/common/policies.module';
import { MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';

import { Constants } from '../../shared/common/helper/constants';
import { AdminGuard } from '../services/admin-guard.service';
import { AdminService } from '../services/admin.service';

import { UsersListComponent } from './users/users-list.component';
import { AddUserComponent } from '../../shared/common/components/add-user/add-user.component';
import { PoliciesListComponent } from './policies/policies-list.component';
import { DynamicPoliciesComponent } from './policies/dynamic-policies/dynamic-policies.component';
import { AlertsListComponent } from './alerts/alerts-list.component';
import { AddAlertComponent } from '../../shared/common/components/add-alert/add-alert.component';
import { SettingsComponent } from './settings/settings.component';
import { ConfigurationComponent } from './configuration/configuration.component';
import { PlaygroundComponent } from './playground/playground.component';
import { AdditionalExplanationComponent } from './additionalExplanation/additionalExplanation.component';

// import { GridModule } from '@progress/kendo-angular-grid';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { NexusComponent } from './nexus/nexus.component';

@NgModule({
  imports: [
    BrowserAnimationsModule,
    CommonModule,
    FormsModule,
    HttpClientModule,
    SharedModule,
    RouterModule,
    NgbModule,
    PoliciesModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatIconModule,
    MatNativeDateModule,
    DialogsModule,
    // GridModule
  ],
  declarations: [
    UsersListComponent,
    AddUserComponent,
    PoliciesListComponent,
    DynamicPoliciesComponent,
    AlertsListComponent,
    AddAlertComponent,
    NexusComponent,
    SettingsComponent,
    ConfigurationComponent,
    PlaygroundComponent,
    AdditionalExplanationComponent,
  ],
  providers: [MatDatepickerModule, Constants, AdminGuard, AdminService],
})
export class AdminModule {}
